import PropTypes from 'prop-types';
import React from 'react';

import { ArrowCaret } from '../../icons/analytics/ArrowCaret';
import { cymbioColors } from '../../../utils/colors';

import styles from './RowsPerPage.module.scss';

export function ReportRowsPerPage(props) {
  const { options, current, onChange } = props;

  return (
    <div className={styles.reportPaginationWrapper}>
      <label>
        <span>Rows per page</span>
        <select onChange={(e) => onChange(Number(e.target.value))} value={current}>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <ArrowCaret color={cymbioColors.analytics.textSecondary} />
      </label>
    </div>
  );
}

ReportRowsPerPage.propTypes = {
  current: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};
